import { render, staticRenderFns } from "./Reference3D.vue?vue&type=template&id=61059c0a&scoped=true"
import script from "./Reference3D.vue?vue&type=script&lang=js"
export * from "./Reference3D.vue?vue&type=script&lang=js"
import style0 from "./Reference3D.vue?vue&type=style&index=0&id=61059c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61059c0a",
  null
  
)

export default component.exports